import React, { useEffect, useState } from 'react'
import axiosInstance from '../services/axiosComman'

function useFetchStandard() {
  const [standardList,setStandardList] = useState([])
  const [standardFullList,setStandardFullList] = useState([])
  function getAllStandard(){
    axiosInstance.get(`/Standards/`).then(res=>{
      let tempdata = res?.data?.data||[] 
      let finalArr = []
      let fullList = []
      res?.data?.data && tempdata.forEach(item=>{
        if(item?.isActive&&item?.keyActivated){

          let temp = {
            value:item?.id,
            label:item?.name
          }
          finalArr.push(temp);
          fullList.push(item)
        }
      })
      setStandardList(finalArr)
      setStandardFullList(fullList)
    }).catch(err=>{
      console.log(err.response?.data);
    })
  }

  useEffect(() => {
    getAllStandard()
  },[])

  return {standardList,standardFullList,getAllStandard}
}

export default useFetchStandard;